import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { close } from 'actionCreators/exit';
import { onSubmit, onSubmitSuccess } from './SaveExit.submit';
import { SaveExitScreen } from './SaveExitScreen';
import * as paths from 'constants/paths';
import { withDeviceContext } from 'context/DeviceContext';
import { NTB_JOURNEY } from 'constants/general';

const ntbSaveExitPaths = [
  paths.YOUR_MAIN_BANK_ACCOUNT,
  paths.DIRECT_DEBIT_INSTRUCTIONS,
  paths.REVIEW_YOUR_LOAN_DETAILS,
  paths.INFORMATION_ABOUT_YOUR_LOAN,
  paths.YOUR_LOAN_APPROVAL,
  paths.YOUR_LOAN_AGREEMENT,
  paths.CHECKING_YOUR_IDENTITY,
  paths.VERIFYING_YOUR_IDENTITY,
  paths.CONGRATULATIONS,
  paths.YOUR_SIGNATURE_IS_NEEDED
];

const existingSaveExitPaths = [
  paths.YOUR_LOAN_APPROVAL,
  paths.YOUR_LOAN_AGREEMENT,
  paths.CONGRATULATIONS
];

function checkSaveExitOrigin(originPath, journey) {
  return journey === NTB_JOURNEY
    ? ntbSaveExitPaths.includes(originPath)
    : existingSaveExitPaths.includes(originPath);
}

const SaveExitScreenForm = reduxForm({
  form: 'SaveExitScreenForm',
  onSubmit,
  onSubmitSuccess,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(SaveExitScreen);

const SaveExitContainer = compose(
  withDeviceContext,
  connect(
    (state) => ({
      isSaveExit: checkSaveExitOrigin(state.router.location.pathname, state.config.journey)
    }),
    (dispatch) => bindActionCreators({ close }, dispatch)
  )
)(SaveExitScreenForm);

export { SaveExitContainer };
